import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface RCProductosIntroScreenProps {
	onNext: () => void
}

export function RCProductosIntroScreen({
	onNext,
}: RCProductosIntroScreenProps) {
	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-6">
					<div className="flex size-16 items-center justify-center rounded-full bg-blue-100">
						<Icon name="package-delivered" className="size-8 text-blue-800" />
					</div>

					<h1 className="font-parkinsans text-center text-3xl leading-10 font-medium text-blue-800">
						Responsabilidad Civil por Productos
					</h1>

					<p className="text-center text-base leading-6 text-neutral-600">
						Cotizá tu seguro de RC por productos elaborados. Protegé tu empresa
						ante reclamos por daños causados por tus productos.
					</p>

					<div className="flex w-full flex-col gap-3 rounded-2xl bg-neutral-100 p-4">
						<p className="font-inter text-sm font-semibold text-blue-800">
							¿Qué necesitás tener a mano?
						</p>
						<ul className="font-inter flex flex-col gap-2 text-sm text-neutral-700">
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Datos de la empresa (nombre, ubicación, actividad)</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Información del personal y facturación anual</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Listado y descripción de productos</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Información sobre proceso de elaboración</span>
							</li>
							<li className="flex items-start gap-2">
								<Icon
									name="check"
									className="mt-0.5 size-4 shrink-0 text-green-500"
								/>
								<span>Datos de control de calidad y distribución</span>
							</li>
						</ul>
					</div>

					<div className="flex w-full items-center gap-3 rounded-xl bg-blue-50 p-3">
						<Icon name="clock" className="size-5 shrink-0 text-blue-600" />
						<p className="font-inter text-sm text-blue-800">
							El proceso toma aproximadamente <strong>10 minutos</strong>
						</p>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-center gap-2 bg-white pt-4 md:bg-transparent md:pt-8">
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onNext}
					className="w-full md:w-auto"
				>
					Comenzar
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
